import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import InstantGiftPreview from "areas/instant-gift/explained/modal"
import ShipInfoLoading from "areas/product/jewlr/loaders/ship-info-loading"

import ShipDetails from "./ship-details"
import Title from "./title"

const Container = styled(Box)`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[10]};
  border-radius: 15px;
  margin-bottom: 18px;
  padding: 16px 20px;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    background-color: ${props.theme.colors.grey[4]};
    border: none;
    border-radius: 0;
    padding: 30px 24px;
  `}
`

const InternalShipping = ({ ship, wizardLoading }) => {
  if (!ship || wizardLoading) {
    return (
      <Container alignItems="center" display="flex" minHeight="130px">
        <Box width="100%">
          <ShipInfoLoading />
        </Box>
      </Container>
    )
  }

  // if ship.ship_days <= 2
  // <>
  //   <Typography color="black" fontSize="16px" mb="3px">
  //     Custom made for you in
  //   </Typography>
  //   <Flex alignItems="center" justifyContent="center">
  //     <Box
  //       as="img"
  //       mr={1}
  //       src={require("images/icons/quick_ship_green.svg")}
  //       height="24px"
  //       width="auto"
  //     />
  //     <Typography color="greenDarker" fontSize="30px" light>
  //       {ship.ship_days < 1 ? "1" : ship.ship_days} DAY
  //       {ship.ship_days > 1 && "S"}
  //     </Typography>
  //   </Flex>
  // </>
  return (
    <Container id="shipping_options_container">
      <Title />
      <ShipDetails />
      <InstantGiftPreview />
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    ship: state.wizard.shipping.main,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalShipping.propTypes = {
  ship: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const Shipping = connect(mapStateToProps, mapDispatchToProps)(InternalShipping)

export default Shipping
